<template>
    <b-card class="h-100">
        <h6 v-if="!embedded" class="font-weight-bold mb-3">{{ title }}</h6>
        <div v-if="loading" class="text-center py-5">
            <b-spinner small type="grow"></b-spinner>
        </div>
        <div v-else-if="!data.length" class="text-muted text-center py-5 small">{{ emptyText }}</div>
        <div v-else class="dashboard-chart-wrap">
            <horizontal-bar-chart-base
                :key="chartRenderKey"
                :chart-data="chartData"
                :options="chartOptions"
            />
        </div>
    </b-card>
</template>

<script>
import HorizontalBarChartBase from './charts/HorizontalBarChartBase.vue'

export default {
    name: 'TopRevenueChart',
    components: { HorizontalBarChartBase },
    props: {
        title: { type: String, required: true },
        data: { type: Array, default: () => [] },
        labelKey: { type: String, default: 'label' },
        loading: { type: Boolean, default: false },
        emptyText: { type: String, default: 'No data for this period.' },
        color: { type: String, default: '#007bff' },
        embedded: { type: Boolean, default: false },
    },
    computed: {
        chartRenderKey() {
            return this.title + '-' + this.data.map((row) => row[this.labelKey] + ':' + row.total).join('|')
        },
        chartData() {
            return {
                labels: this.data.map((row) => row[this.labelKey]),
                datasets: [{
                    label: 'Revenue',
                    backgroundColor: this.color,
                    data: this.data.map((row) => Number(row.total) || 0),
                }],
            }
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                layout: { padding: { bottom: 8, left: 4, right: 8 } },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback(value) {
                                return '$' + Number(value).toLocaleString()
                            },
                        },
                    }],
                },
                tooltips: {
                    callbacks: {
                        label(tooltipItem) {
                            const value = tooltipItem.xLabel || tooltipItem.value || 0
                            return '$' + Number(value).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                        },
                    },
                },
            }
        },
    },
}
</script>

<style scoped>
.dashboard-chart-wrap {
    height: 320px;
    position: relative;
}
.dashboard-chart-wrap ::v-deep > div {
    height: 100% !important;
}
</style>
